import ProxyBase from '../../../../../core/proxies/ProxyBase'

export class FinancialStatementsProxy extends ProxyBase {
  getFinancialStatementsTable(params) {
    return this.post('GetData', params)
  }

  financialStatementsOneYearTable(params) {
    return this.post('GetData', params)
  }

  downloadFinancialData(params) {
    return this.post('ExportData', params, {}, 'download')
  }

  getDataTransform(params) {
    return this.post('GetDataTransform', params)
  }
}

export default new FinancialStatementsProxy('FinancialStatement/')
